import OrderDocuments from '@/views/Driver/components/Order/components/Documents/Documents'
import TrackDocuments from '@/views/Driver/components/Track/components/Documents/Documents'

export default {
  components: { OrderDocuments, TrackDocuments },
  setup(props, context) {
    const { id, type } = context.root.$route.params

    return {
      id,
      type,
    }
  },
}
